import { render, staticRenderFns } from "./TestDetailCoordinator.vue?vue&type=template&id=347ec459&scoped=true"
import script from "./TestDetailCoordinator.vue?vue&type=script&lang=js"
export * from "./TestDetailCoordinator.vue?vue&type=script&lang=js"
import style0 from "./TestDetailCoordinator.vue?vue&type=style&index=0&id=347ec459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347ec459",
  null
  
)

export default component.exports